import { CnInput as CnInputView } from './cn-input';
import locale from '@/locales';
import { withI18n } from 'panda-i18n';
var CnInput = withI18n(CnInputView, { locale: locale });
export { CnInput };
